import { render, staticRenderFns } from "./create-balance-payment-form.vue?vue&type=template&id=10f0727d&"
import script from "./create-balance-payment-form.vue?vue&type=script&lang=js&"
export * from "./create-balance-payment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports